const initialState = {
    history: [],
};
const visitHistory = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_VISIT_HISTORY':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default visitHistory;
